import { NodeExtension, ParamType } from 'helicon';

export const QuantizerExtension: NodeExtension = {
  type: 'Quantizer',
  processor: '/QuantizerProcessor.js',
  description: {
    numberOfInputs: 0,
    numberOfOutputs: 2,
    outputChannelCount: [1, 1],
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    params: {
      signal: {
        type: ParamType.AudioParam,
        default: 0,
      },
      values: {
        type: ParamType.Value,
        default: [0],
      },
      range: {
        type: ParamType.Value,
        default: 100,
      },
    },
    signals: {
      position: {
        readable: true,
        trigger: true,
        default: 0,
      },
    },
  },
};
